/**
 * Obtém a diferença entre dois arrays (o que está em um que não está no outro)
 * @param {array} array1 Array principal
 * @param {array} array2 Array de comparação
 */
export function getDifferenceBetween(array1, array2) {
  if (!array1 || !array2) return [];

  return array1.filter((item) => !array2.includes(item));
}